import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbButtonItem } from '../../types/pbBlocks';
import { getAdvanced, getButtonLinkType, getButtonType, parseStyleString } from '../utils';

export type ButtonItemType = ContentTypeObject & PbButtonItem;

/**
 * Aggregates the configuration of a button item element.
 * @param node
 */
export function buttonItemConfigAggregator(node: CustomHtmlElement): ButtonItemType {
    const childNode = node.childNodes[0] as CustomHtmlElement;
    const childNodeClassNames = childNode.classNames;

    const style = parseStyleString(childNode.attributes.style);

    const buttonBackgroundColour = node.attributes['background_colour'];
    const buttonTextColour = node.attributes['text_colour'];

    return {
        ...getAdvanced(childNode, style),
        appearance: node.attributes['data-appearance'],
        buttonText: childNode.textContent,
        buttonType: getButtonType(childNodeClassNames),
        link: childNode.attributes['href'],
        linkType: getButtonLinkType(childNode.attributes['data-link-type']),
        openInNewTab: childNode.attributes['target'] === '_blank',
        uniqueID: node.attributes['data-pb-style'],
        buttonTextColour,
        buttonBackgroundColour,
    };
}
